import laroute from '@laroute';

export const getShortLinkForMoment = async(eventVideoCropId) => {
	try {
		const shortlinkResponse = await fetch(laroute.route('api.event_video_crop.shortlink', { eventVideoCrop: eventVideoCropId }), {
			method:  'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		const shortlink = await shortlinkResponse.json();
		return shortlink.url;
	} catch (e) {
		console.error('Unable to get shortlink: ' + e);
	}
	return null;
};
